export class Push {

    public id: string = "0";
    public title: string;
    public text: string;
    public date_create: Date;
    public url: string;
    public sent: boolean;
    
    public date_to_send: Date;
    public time_to_send: string;

    public push_type: string; //all, event, list
    public event_id: string; 
    public list: any[] = []

    constructor() {}
}